import urls from "../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../utils/service";

export async function getEnquiry(payload?: {
  pageIndex?: number;
  pageSize?: number;
  search?: string;
}) {
  try {
    const pageIndex = payload?.pageIndex ?? 0;
    const pageSize = payload?.pageSize ?? 25;
    const search = payload?.search ?? "";
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      `${urls.Enquiry}?pageIndex=${pageIndex}&pageSize=${pageSize}&search=${encodeURIComponent(search)}`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}
